"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usageTrackerAsBeacon = exports.usageTracker = void 0;

var _usageTracker = require("usage-tracker");

var _events = _interopRequireDefault(require("ComposeUI/events.yaml"));

var DEFAULTS = {
  events: _events.default,
  properties: {
    namespace: 'content-composer'
  },
  onError: function onError(err) {
    throw err;
  },
  lastKnownEventProperties: ['screen', 'subscreen']
};
var usageTracker = (0, _usageTracker.createTracker)(DEFAULTS);
exports.usageTracker = usageTracker;
var usageTrackerAsBeacon = (0, _usageTracker.createTracker)(Object.assign({}, DEFAULTS, {
  isBeforeUnload: true
}));
exports.usageTrackerAsBeacon = usageTrackerAsBeacon;